export default function breakQueryString(query) {
    query = query.replace('?', '');

    if(!query.length) {
        return null;
    }

    const parts = query.split('&');
    const output = {};

    parts.forEach(part => {
        const [name, value] = part.split('=');
        output[name] = value;
    });

    return output;
}